import React, { useCallback, useEffect } from "react";
import { LineChartOutlined } from "@ant-design/icons";
import { SectionBlock, LeadText } from "./shared";
import { useFetchApi } from "../../../hooks/useFetchApi";
import { ChartCard } from "./ChartCard";

interface Props {
  selectedStock: any;
  baseCurrency: string;
  bodyText?: string;
}

const PriceHistory: React.FC<Props> = ({
  selectedStock,
  baseCurrency,
  bodyText = "Over the long run the share has trended upward with plenty of dips along the way. <strong>The past is never a promise</strong> — it just shows the kind of ups and downs that are normal.",
}) => {
  const {
    execute: generateSharePriceGraph,
    loading: sharePriceLoading,
    response: sharePriceGraphData,
  } = useFetchApi("/api/dynamic-graph");

  const fetchGraph = useCallback(() => {
    if (!selectedStock) return;

    generateSharePriceGraph({
      selectedStocks: [selectedStock],
      filter: "quarterly",
      baseCurrency,
      selectedMetrics: [
        { name: "share_price", sortableId: "1-Investor Ratio-1" },
      ],
      period: "5",
    });
  }, [selectedStock, baseCurrency]);

  useEffect(() => {
    fetchGraph();
  }, [fetchGraph]);

  return (
    <SectionBlock
      icon={<LineChartOutlined />}
      title="How it has moved in the past"
      subtitle="Share price over the last 5 years"
    >
      <LeadText>
        <span dangerouslySetInnerHTML={{ __html: bodyText }} />
      </LeadText>

      <div className="mt-4">
        <ChartCard
          graphData={sharePriceGraphData}
          loading={sharePriceLoading}
          baseCurrency={baseCurrency}
          defaultChartType="area"
          showFilterToggle={false}
        />
      </div>
    </SectionBlock>
  );
};

export default PriceHistory;
